import axios from '@/lib/axios'
import { useQuery } from '@tanstack/vue-query'
import { ref } from 'vue'
import { ToastInterface, useToast } from 'vue-toastification'

interface Props {
	requestId?: string
	immediate?: boolean
}



const requestDownloadPdf = async (props: Pick<Props, 'requestId'>, toast: ToastInterface) => {
	const { data, headers } = await axios.get(
		`api/requests/${props.requestId}/download-pdf`,
		{
			responseType: 'blob',
		}
	)

	toast.success('Archivo descargado correctamente')

	// Obtener los headers correctamente
	const contentDisposition = headers['content-disposition']
	let fileName = 'archivo.pdf'

	if (contentDisposition) {
		const match = contentDisposition.match(/filename="(.+?)"/)
		if (match && match[1]) {
			fileName = decodeURIComponent(match[1])
		}
	}

	// Crear URL para el Blob y descargar el archivo
	const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
	const link = document.createElement('a')
	link.href = url
	link.setAttribute('download', fileName)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	window.URL.revokeObjectURL(url)


	return data
}

const useRequestDownlandPdf = (props: Props) => {
	const requestId = ref<string>('')
	const toast = useToast()

	const { data, isLoading, refetch, isRefetching, isFetching } = useQuery(
		['requestDownloadPdf', requestId.value],
		() =>
			requestDownloadPdf({ requestId: requestId.value || props.requestId! }, toast),
		{
			enabled: props.immediate,
		}
	)

	return {
		data,
		isLoading,
		refetch,
		isRefetching,
		requestId,
		isFetching,
	}
}

export default useRequestDownlandPdf
